import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { expVal } from '@atlassian/jira-feature-experiments';
import SearchNoResultsImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/empty/components/search-no-results/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

export const EmptyList = ({ intl: { formatMessage } }: Intl) => {
	const noIssues = formatMessage(
		expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
			? messages.noIssuesIssueTermRefresh
			: messages.noIssues,
	);

	return (
		<>
			<Box xcss={ImageWrapperStyles}>
				<SearchNoResultsImage alt="" />
			</Box>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{noIssues}</p>
		</>
	);
};

/* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */
export default injectIntl(EmptyList);

const ImageWrapperStyles = xcss({
	height: '165px',
	width: '150px',
});
